import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "textimportcharacterset"
    }}>{`TextImportCharacterSet`}</h1>
    <p>{`Character set options for importing text files.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ANSI`}</strong>{` = 1095652169`}</p>
      <p parentName="blockquote">{`The ANSI character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`RECOMMENDSHIFTJIS83PV`}</strong>{` = 1412969328`}</p>
      <p parentName="blockquote">{`The Recommend:Shift_JIS 83pv character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SHIFTJIS90PV`}</strong>{` = 1413034096`}</p>
      <p parentName="blockquote">{`The Shift_JIS 90pv character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SHIFTJIS90MS`}</strong>{` = 1413034093`}</p>
      <p parentName="blockquote">{`The Shift_JIS 90ms character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`GB2312`}</strong>{` = 1416061535`}</p>
      <p parentName="blockquote">{`The GB2312 character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CHINESE_BIG_5`}</strong>{` = 1415799349`}</p>
      <p parentName="blockquote">{`The Chinese Big 5 character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`MACINTOSH_CE`}</strong>{` = 1416446789`}</p>
      <p parentName="blockquote">{`The Macintosh CE (Cantral European) character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`MACINTOSH_CYRILLIC`}</strong>{` = 1416446841`}</p>
      <p parentName="blockquote">{`The Macintosh Cyrillic character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`MACINTOSH_GREEK`}</strong>{` = 1416447858`}</p>
      <p parentName="blockquote">{`The Macintosh Greek character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`MACINTOSH_TURKISH`}</strong>{` = 1416451186`}</p>
      <p parentName="blockquote">{`The Macintosh Turkish character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`WINDOWS_CYRILLIC`}</strong>{` = 1417102201`}</p>
      <p parentName="blockquote">{`The Windows Cyrillic character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`WINDOWS_EE`}</strong>{` = 1417102661`}</p>
      <p parentName="blockquote">{`The Windows EE (Eastern European) character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`WINDOWS_GREEK`}</strong>{` = 1417103218`}</p>
      <p parentName="blockquote">{`The Windows Greek character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`WINDOWS_TURKISH`}</strong>{` = 1417106549`}</p>
      <p parentName="blockquote">{`The Windows Turkish character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`GB18030`}</strong>{` = 1416061491`}</p>
      <p parentName="blockquote">{`The GB18030 character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`KSC5601`}</strong>{` = 1414230883`}</p>
      <p parentName="blockquote">{`The KSC5601 character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`WINDOWS_BALTIC`}</strong>{` = 1417101940`}</p>
      <p parentName="blockquote">{`Tthe Windows Baltic character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`WINDOWS_CE`}</strong>{` = 1417102149`}</p>
      <p parentName="blockquote">{`The Windows CE (Central European) character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`MACINTOSH_ROMAN`}</strong>{` = 1416450669`}</p>
      <p parentName="blockquote">{`The Macintosh Roman character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`MACINTOSH_CROATIAN`}</strong>{` = 1416446834`}</p>
      <p parentName="blockquote">{`The Macintosh Croatian character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`MACINTOSH_ICELANDIC`}</strong>{` = 1416448355`}</p>
      <p parentName="blockquote">{`The Macintosh Icelandic character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`MACINTOSH_ROMANIAN`}</strong>{` = 1416450671`}</p>
      <p parentName="blockquote">{`The Macintosh Romanian character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CYRILLIC_KOI8R`}</strong>{` = 1416312946`}</p>
      <p parentName="blockquote">{`The Cyrillic (KOI8R) character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CYRILLIC_KOI8U`}</strong>{` = 1416312949`}</p>
      <p parentName="blockquote">{`The Cyrillic (KOI8U) character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CYRILLIC_CP855`}</strong>{` = 1415788597`}</p>
      <p parentName="blockquote">{`The Cyrillic (CP855) character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`DOS_LATIN_2`}</strong>{` = 1415867442`}</p>
      <p parentName="blockquote">{`The DOS Latin 2 character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CYRILLIC_ISO`}</strong>{` = 1416184697`}</p>
      <p parentName="blockquote">{`The Cyrillic (ISO) character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`GREEK_ISO`}</strong>{` = 1416185707`}</p>
      <p parentName="blockquote">{`The Greek (ISO) character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CENTRALEUROPEAN_ISO`}</strong>{` = 1416184645`}</p>
      <p parentName="blockquote">{`The Central European (ISO) character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TURKISH_ISO`}</strong>{` = 1416189045`}</p>
      <p parentName="blockquote">{`The Turkish (ISO) character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`MACINTOSH_GREEK_SHARED_CAPS`}</strong>{` = 1416447794`}</p>
      <p parentName="blockquote">{`The Macintosh Greek (Shared caps) character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`MACINTOSH_ARABIC`}</strong>{` = 1416446322`}</p>
      <p parentName="blockquote">{`The Macintosh Arabic character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`MACINTOSH_HEBREW`}</strong>{` = 1416448098`}</p>
      <p parentName="blockquote">{`The Macintosh Hebrew character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`WINDOWS_ARABIC`}</strong>{` = 1417101682`}</p>
      <p parentName="blockquote">{`The Windows Arabic character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`WINDOWS_HEBREW`}</strong>{` = 1417103458`}</p>
      <p parentName="blockquote">{`The Windows Hebrew character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ARABIC_ASMO`}</strong>{` = 1415672685`}</p>
      <p parentName="blockquote">{`The Arabic ASMO character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ARABIC_ASMO_TRANSPARENT`}</strong>{` = 1415672692`}</p>
      <p parentName="blockquote">{`The Arabic ASMO transparent character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`UTF16`}</strong>{` = 1937125686`}</p>
      <p parentName="blockquote">{`The Unicode UTF16 character set.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`UTF8`}</strong>{` = 1937134904`}</p>
      <p parentName="blockquote">{`The Unicode UTF8 character set.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      